
import React from 'react';

interface BlogMetaProps {
  author: string;
  publishedAt: string;
  readingTime: number;
  views: number;
}

export default function BlogMeta({
  author,
  publishedAt,
  readingTime,
  views,
}: BlogMetaProps) {
  // Guard against invalid dates – fallback to an empty string if parsing fails
  const date = new Date(publishedAt);
  const formattedDate = isNaN(date.getTime())
    ? ''
    : date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      });

  // Guard against non‑numeric values for readingTime and views
  const safeReadingTime = Number.isFinite(readingTime) ? readingTime : 0;
  const safeViews = Number.isFinite(views) ? views : 0;

  return (
    <div className="flex flex-wrap items-center gap-5 text-sm text-neutral-500">
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 flex items-center justify-center bg-primary/10 rounded-full">
          <i className="ri-user-line text-primary text-sm"></i>
        </div>
        <span className="font-medium text-neutral-700">{author}</span>
      </div>

      <div className="flex items-center gap-1.5">
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-calendar-line"></i>
        </div>
        <span>{formattedDate}</span>
      </div>

      <div className="flex items-center gap-1.5">
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-time-line"></i>
        </div>
        <span>{safeReadingTime} min de leitura</span>
      </div>

      <div className="flex items-center gap-1.5">
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-eye-line"></i>
        </div>
        <span>{safeViews.toLocaleString('pt-BR')} visualizações</span>
      </div>
    </div>
  );
}
